import { LoadingSlide } from "@components/title-slide-view";
import { CustomMetricsProvider } from "@features/custom-metrics/hooks/custom-metrics-provider";
import { SalesPageV3Provider } from "@features/sales-v3";
import { SalesV3Provider } from "@features/sales-v3/table/contexts";
import { useNorthbeamQuery } from "@hooks/http";
import {
  NAVBAR_QUERY,
  type Navbar as NavbarQuery,
} from "@north-beam/nb-client-side";

import { type OrdersApiStepMetadata } from "../orders-api/step-metadata";

import { AttributionTable } from "./attribution-table";

interface Props {
  stepMetadata: OrdersApiStepMetadata;
  updateStepMetadata: (data: OrdersApiStepMetadata) => void;
}

export const AttributionValidation = ({
  stepMetadata,
  updateStepMetadata,
}: Props) => {
  const { data, loading } = useNorthbeamQuery<NavbarQuery>(NAVBAR_QUERY, {
    doNotRaiseErrorOnFailure: true,
  });

  if (loading) {
    return (
      <div className="mt-12">
        <div className="text-2xl font-semibold">
          Verify your Spend, Visits, Revenue and Orders
        </div>
        <LoadingSlide />
      </div>
    );
  }

  if (!data?.me.datasetExists) {
    return (
      <div className="mt-12">
        <div className="text-2xl font-semibold">
          Verify your Spend, Visits, Revenue and Orders
        </div>
        <div className="my-4">
          Your attribution data is not ready yet. Check in a few hours.
        </div>
      </div>
    );
  }

  return (
    <div className="mt-12">
      <div className="text-2xl font-semibold">
        Verify your Spend, Visits, Revenue and Orders
      </div>
      <CustomMetricsProvider>
        <SalesV3Provider>
          <SalesPageV3Provider defaultAccountingMode="cash">
            <AttributionTable
              stepMetadata={stepMetadata}
              updateStepMetadata={updateStepMetadata}
            />
          </SalesPageV3Provider>
        </SalesV3Provider>
      </CustomMetricsProvider>
    </div>
  );
};
